import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    dead: {
      campaigns: null,
      sources: null,
      statuses: null,
    },
  },
});

const getters = {
  filters(state) {
    return state.filters.dead;
  }
};

const mutations = {
  setOneFilter(state, [filterObject, filter, value]) {
    state.filters[filterObject][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  resetFilters(state, filterObject) {
    // Make sure to update state default
    state.filters[filterObject] = {
      campaigns: null,
      sources: null,
      statuses: null,
    };

    store.dispatch('updateUserAppFilter')
  },
};

const actions = {};

const DeadStateStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default DeadStateStore;
